<ng-container *transloco="let t">
    <div
        #unionRef
        class="tms-map-button-solo"
    >
        <bazis-button
            *ngIf="transformSettings.union"
            fill="clear"
            (click)="union()"
        >
            <!-- <bazis-icon
            slot="icon-only"
            name=""
        ></bazis-icon> -->
            U
        </bazis-button>
        <bazis-tooltip
            [reference]="unionRef"
            placement="left"
            class="bh-popper-z-index"
            [isStatic]="true"
            [offset]="[-12, 0]"
            [arrow]="false"
            >{{ t('map.tooltip.unionRef') }}</bazis-tooltip
        >
    </div>
</ng-container>
